import React from "react";

const SuperTrack = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#007AFF"
            fillRule="evenodd"
            d="M25.601 3.862v.336a8.866 8.866 0 0 0-6.57 2.08 9.072 9.072 0 0 0-3.052 5.356 9.142 9.142 0 0 0 1.06 6.09 8.961 8.961 0 0 0 4.676 3.977 4.811 4.811 0 0 0-1.463 2.215 4.865 4.865 0 0 0-.074 2.664l-4.512 2.639c-.431.253-.745.67-.874 1.157a1.931 1.931 0 0 0 .185 1.444c.25.436.661.754 1.143.885.48.13.994.063 1.426-.188l4.98-2.912c.375.204.776.356 1.192.451l-6.142 3.592a2.597 2.597 0 0 1-1.984.261 2.63 2.63 0 0 1-1.59-1.23L4.348 15.747a2.689 2.689 0 0 1-.258-2.01 2.656 2.656 0 0 1 1.216-1.611l16.72-9.775a2.601 2.601 0 0 1 3.032.302 1.55 1.55 0 0 1 .543 1.208Z"
            clipRule="evenodd"
        />
        <path
            fill="#FFA700"
            fillRule="evenodd"
            d="M25.54 6.952a.79.79 0 0 1-.219.566.771.771 0 0 1-.853.175.771.771 0 0 1-.418-.435.79.79 0 0 1-.053-.306V5.43a7.678 7.678 0 0 0-4.683 2.25 7.855 7.855 0 0 0-2.222 4.741h1.504c.201.006.392.09.533.236a.787.787 0 0 1 0 1.091.767.767 0 0 1-.533.236h-1.504a7.855 7.855 0 0 0 2.221 4.742 7.677 7.677 0 0 0 4.684 2.25v-1.523a.786.786 0 0 1 .233-.54.767.767 0 0 1 1.077 0 .786.786 0 0 1 .233.54v1.523a7.677 7.677 0 0 0 4.683-2.25 7.855 7.855 0 0 0 2.221-4.742H30.94a.763.763 0 0 1-.558-.222.781.781 0 0 1-.234-.56.789.789 0 0 1 .234-.559.768.768 0 0 1 .558-.222h1.504a7.856 7.856 0 0 0-2.221-4.742 7.678 7.678 0 0 0-4.683-2.25v1.524Zm1.316 8.364a.786.786 0 0 0 0-1.103L25.54 12.88v-2.023a.79.79 0 0 0-.219-.565.772.772 0 0 0-.553-.236.764.764 0 0 0-.553.236.783.783 0 0 0-.218.565V13.2a.79.79 0 0 0 .226.553l1.542 1.562a.772.772 0 0 0 .546.23.762.762 0 0 0 .545-.229Z"
            clipRule="evenodd"
        />
        <path
            fill="#FF6961"
            d="M24.768 29.482c2.154 0 3.9-1.768 3.9-3.949 0-2.18-1.746-3.949-3.9-3.949s-3.9 1.768-3.9 3.95c0 2.18 1.746 3.948 3.9 3.948Z"
        />
        <path
            fill="#fff"
            d="M25.495 23.775H24.04c-.557 0-1.009.458-1.009 1.022v1.472c0 .564.452 1.022 1.01 1.022h1.453c.557 0 1.009-.458 1.009-1.022v-1.472c0-.564-.452-1.022-1.01-1.022Z"
            opacity={0.2}
        />
        <path
            fill="#fff"
            d="M25.268 24.35h-1c-.37 0-.669.303-.669.677v1.012c0 .374.3.677.67.677h.999c.37 0 .67-.303.67-.677v-1.012c0-.374-.3-.678-.67-.678Z"
        />
    </svg>
);

export default SuperTrack;
